/**
 * Количество секунд, через сколько пользователь сможет отправить код повторно
 * */
export const SEND_EMAIL_ATTEMPT_COUNTDOWN_FROM = 60;
